import { useContext } from "react"
import cc from "classcat"
import { LocaleContext } from "contexts"

import { CheckCircleIcon } from "@heroicons/react/20/solid"
import useTranslations from "hooks/useTranslations"
import LocalizedLink from "components/LocalizedLink"

interface ReportCardProps {
  title: string
  description: string
  link: string
  checked: boolean
  CoverImage: () => React.ReactElement
  onClick
}

export function ReportCard({
  title,
  description,
  CoverImage,
  checked,
  onClick,
  link,
}: ReportCardProps) {
  const { locale } = useContext(LocaleContext)

  const { buttonMore } = useTranslations()
  return (
    <div
      onClick={onClick}
      aria-label={title}
      aria-description={`${description}`}
      className={cc([
        checked ? "border-transparent" : "border-gray-300",
        "focus-within:ring-kkm-green-500 relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus-within:ring-2 focus:outline-none",
      ])}
    >
      <div className="flex flex-1">
        <div className="flex flex-col justify-between gap-6 pt-1">
          <div className="">
            <div className="block font-display text-base font-bold text-gray-900">
              {title}
            </div>
            <div className="mt-1 flex items-center text-sm text-gray-500">
              {description}
            </div>
            {link && ["fi-fi", "sv-fi"].includes(locale) && (
              <LocalizedLink
                to={link}
                target="_blank"
                className="text-sm font-semibold text-teal-600 underline hover:text-teal-700"
              >
                {buttonMore} <span className="text-xs">→</span>
              </LocalizedLink>
            )}
          </div>
          <CoverImage className="rounded-lg" />
        </div>
      </div>

      <CheckCircleIcon
        className={cc([
          "absolute right-1 top-1 h-5 w-5",
          checked ? "text-kkm-green" : "text-zinc-200",
        ])}
        aria-hidden="true"
      />

      <div
        className={cc([
          checked ? "border-kkm-green/90" : "border-transparent",
          "pointer-events-none absolute -inset-px rounded-lg border-2 focus-within:border",
        ])}
        aria-hidden="true"
      />
    </div>
  )
}
